import { render, staticRenderFns } from "./AddDefaultCoupon.vue?vue&type=template&id=1fe149b3"
import script from "./AddDefaultCoupon.vue?vue&type=script&lang=ts"
export * from "./AddDefaultCoupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports